import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteInfo, faqData } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function AboutPage() {
  const breadcrumbItems = [{ label: '关于我们' }];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    logo: 'http://jtqzai.cn/logo.png',
    description: siteInfo.description,
    foundingDate: `${siteInfo.foundedYear}`,
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '上海',
      addressRegion: '浦东新区',
      streetAddress: siteInfo.contact.address,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contact.email,
      contactType: '客户服务',
      availableLanguage: 'Chinese',
    },
    sameAs: [siteInfo.url],
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `关于我们 - ${siteInfo.name}`,
    description: `了解${siteInfo.name}的品牌故事、平台数据和联系方式。`,
    url: `${siteInfo.url}/about`,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
    mainEntity: orgSchema,
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <title>{`关于我们 - ${siteInfo.name} | 51黑料吃瓜网在线观看`}</title>
      <meta
        name="description"
        content={`了解${siteInfo.name}的品牌故事、平台声誉与联系方式。${siteInfo.name}是全网最具影响力的娱乐八卦爆料平台。`}
      />
      <meta
        name="keywords"
        content="51黑料网,关于我们,品牌介绍,联系方式,商务合作,51黑料吃瓜网"
      />
      <link rel="canonical" href="http://jtqzai.cn/about" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`关于我们 - ${siteInfo.name}`} />
      <meta
        property="og:description"
        content={`了解${siteInfo.name}的品牌故事、平台声誉与联系方式。`}
      />
      <meta property="og:url" content="http://jtqzai.cn/about" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`关于我们 - ${siteInfo.name}`} />
      <meta
        name="twitter:description"
        content={`了解${siteInfo.name}的品牌故事、平台声誉与联系方式。`}
      />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen flex flex-col bg-background-950">
        <header>
          <Navbar />
        </header>

        <main className="pt-20 md:pt-24">
          <Breadcrumb items={breadcrumbItems} />

          {/* Hero Banner */}
          <section className="relative w-full py-16 md:py-24 overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dark%20modern%20cityscape%20with%20dramatic%20lighting%20and%20mysterious%20atmosphere%2C%20cinematic%20red%20and%20amber%20color%20tones%2C%20editorial%20photography%20style&width=1600&height=600&seq=about-hero-01&orientation=landscape"
                alt="关于51黑料网"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950" />
            </div>
            <div className="relative z-10 w-full px-4 md:px-8 text-center">
              <div className="max-w-3xl mx-auto">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-500 mx-auto mb-6">
                  <span className="text-background-50 font-black text-2xl">51</span>
                </div>
                <h1 className="text-3xl md:text-4xl font-black text-foreground-50 mb-4">
                  关于 {siteInfo.name}
                </h1>
                <p className="text-base md:text-lg text-foreground-400 max-w-xl mx-auto leading-relaxed">
                  {siteInfo.slogan}。我们致力于为全网吃瓜群众提供最真实、最及时、最独家的娱乐爆料内容。
                </p>
              </div>
            </div>
          </section>

          {/* Brand Story */}
          <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-900/50">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-6 md:mb-8">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-400">
                  <i className="ri-book-open-line" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100">品牌故事</h2>
              </div>
              <div className="space-y-4 text-sm md:text-base text-foreground-400 leading-relaxed">
                <p>
                  <strong className="text-foreground-200">51黑料网</strong>创立于{siteInfo.foundedYear}年，是国内最早专注于娱乐八卦爆料的内容平台之一。我们始终秉持"真实、及时、深度"的内容理念，为广大吃瓜群众提供第一手的娱乐圈内幕资讯。
                </p>
                <p>
                  从创立之初，51黑料网就建立了严格的爆料审核机制。我们的采编团队由超过320名来自全国各地的娱乐记者、圈内线人和资深媒体人组成，覆盖北京、上海、横店、长沙等娱乐产业重镇，确保每一条爆料都经过至少两个独立信源的交叉验证。
                </p>
                <p>
                  截至目前，51黑料网已累计发布爆料超过12,580条，涵盖明星塌房、每日黑料、独家猛料、影视圈内幕、网红翻车、综艺黑幕等六大核心板块。我们的日活跃用户超过85万，已成为全网最具影响力的娱乐爆料平台。
                </p>
                <p>
                  我们深知爆料行业面临的争议与挑战，因此始终坚持在法律法规允许的范围内开展报道工作。对于涉及隐私的内容，我们会进行必要的脱敏处理；对于可能对当事人造成重大影响的内容，我们会保留充分的证据材料。
                </p>
              </div>
            </div>
          </section>

          {/* Platform Stats */}
          <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-950">
            <div className="max-w-5xl mx-auto">
              <div className="flex items-center gap-3 mb-8 md:mb-10">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-400">
                  <i className="ri-bar-chart-box-line" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100">平台数据</h2>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
                {siteInfo.stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="p-5 md:p-6 rounded-xl bg-background-900 border border-background-800/50 text-center"
                  >
                    <div className="text-2xl md:text-3xl font-black text-primary-400 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                <div className="p-5 rounded-xl bg-background-900 border border-background-800/50">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-6 h-6 flex items-center justify-center text-primary-400">
                      <i className="ri-article-line" />
                    </div>
                    <h3 className="text-base font-bold text-foreground-200">内容覆盖</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    覆盖{categories.length}大核心分类，日均更新8-15篇高质量爆料文章，重大事件承诺2小时内首发。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-900 border border-background-800/50">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-6 h-6 flex items-center justify-center text-accent-400">
                      <i className="ri-user-voice-line" />
                    </div>
                    <h3 className="text-base font-bold text-foreground-200">用户群体</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    核心用户年龄18-35岁，女性占比62%，一二线城市用户占比58%，月均页面浏览量超过2.5亿次。
                  </p>
                </div>
                <div className="p-5 rounded-xl bg-background-900 border border-background-800/50">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-6 h-6 flex items-center justify-center text-secondary-400">
                      <i className="ri-shield-check-line" />
                    </div>
                    <h3 className="text-base font-bold text-foreground-200">内容保障</h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    双重信源验证机制，专业法务团队审核，所有独家爆料保留原始证据材料，确保内容真实可靠。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-900/50">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-8 md:mb-10">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500/20 text-secondary-400">
                  <i className="ri-question-answer-line" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100">常见问题</h2>
              </div>

              <div className="space-y-4">
                {faqData.map((faq, index) => (
                  <details
                    key={index}
                    className="group rounded-xl bg-background-900 border border-background-800/50 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <h3 className="text-sm md:text-base font-bold text-foreground-200 pr-4">
                        {faq.question}
                      </h3>
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-800 text-foreground-500 shrink-0 group-open:bg-primary-500/20 group-open:text-primary-400 transition-colors">
                        <i className="ri-add-line group-open:hidden" />
                        <i className="ri-subtract-line hidden group-open:inline" />
                      </div>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-950">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-8 md:mb-10">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-400">
                  <i className="ri-contacts-line" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-100">联系我们</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
                {/* Contact Info Cards */}
                <div className="p-5 md:p-6 rounded-xl bg-background-900 border border-background-800/50">
                  <h3 className="text-base font-bold text-foreground-200 mb-4">联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 shrink-0">
                        <i className="ri-mail-line" />
                      </div>
                      <div>
                        <div className="text-xs text-foreground-500 mb-0.5">电子邮箱</div>
                        <a
                          href={`mailto:${siteInfo.contact.email}`}
                          className="text-sm md:text-base text-foreground-300 hover:text-primary-300 transition-colors"
                        >
                          {siteInfo.contact.email}
                        </a>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-400 shrink-0">
                        <i className="ri-wechat-line" />
                      </div>
                      <div>
                        <div className="text-xs text-foreground-500 mb-0.5">微信公众号</div>
                        <span className="text-sm md:text-base text-foreground-300">
                          {siteInfo.contact.wechat}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-400 shrink-0">
                        <i className="ri-weibo-line" />
                      </div>
                      <div>
                        <div className="text-xs text-foreground-500 mb-0.5">官方微博</div>
                        <a
                          href={siteInfo.url}
                          target="_blank"
                          rel="noopener noreferrer nofollow"
                          className="text-sm md:text-base text-foreground-300 hover:text-primary-300 transition-colors"
                        >
                          {siteInfo.contact.weibo}
                        </a>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-700/20 text-foreground-400 shrink-0">
                        <i className="ri-map-pin-line" />
                      </div>
                      <div>
                        <div className="text-xs text-foreground-500 mb-0.5">公司地址</div>
                        <span className="text-sm md:text-base text-foreground-300">
                          {siteInfo.contact.address}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Business Cooperation */}
                <div className="p-5 md:p-6 rounded-xl bg-background-900 border border-background-800/50">
                  <h3 className="text-base font-bold text-foreground-200 mb-4">商务合作</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                    51黑料网欢迎各类品牌进行商务合作。我们提供内容植入、专题报道、活动推广等多种合作方式。我们的用户群体精准覆盖18-35岁娱乐消费群体，具有较高的消费转化潜力。
                  </p>
                  <div className="space-y-3 mb-5">
                    <div className="flex items-center gap-2 text-sm text-foreground-400">
                      <div className="w-5 h-5 flex items-center justify-center text-primary-400">
                        <i className="ri-check-line" />
                      </div>
                      品牌内容植入与软广合作
                    </div>
                    <div className="flex items-center gap-2 text-sm text-foreground-400">
                      <div className="w-5 h-5 flex items-center justify-center text-primary-400">
                        <i className="ri-check-line" />
                      </div>
                      专题报道与深度内容定制
                    </div>
                    <div className="flex items-center gap-2 text-sm text-foreground-400">
                      <div className="w-5 h-5 flex items-center justify-center text-primary-400">
                        <i className="ri-check-line" />
                      </div>
                      线下活动推广与联合营销
                    </div>
                    <div className="flex items-center gap-2 text-sm text-foreground-400">
                      <div className="w-5 h-5 flex items-center justify-center text-primary-400">
                        <i className="ri-check-line" />
                      </div>
                      独家爆料权竞标与内容授权
                    </div>
                  </div>
                  <a
                    href={`mailto:${siteInfo.contact.email}?subject=商务合作咨询`}
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
                  >
                    <i className="ri-mail-send-line" /> 发送合作邮件
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}
